<template>
    <div class="card-body">
      <div class="input-states">
        <br>
        <div class="form-horizontal">
          <div class="form-group">
            <div class="row">
              <label class="col-sm-3 control-label">Sección</label>
              <div class="col-sm-8">
                <select class="form-control test" v-model="selectedSection" id="typeUser">
                  <option v-for="sec in section" v-bind:key="sec">
                    {{ sec }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <label class="col-sm-3 control-label">Título</label>
              <div class="col-sm-8">
                <input
                  type="text"
                  placeholder="Título"
                  id="title"
                  class="form-control"
                  v-model="title"
                />
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <label class="col-sm-3 control-label">Descripción</label>
              <div class="col-sm-8">
                <input
                  type="text"
                  placeholder="Descripción"
                  id="description"
                  class="form-control"
                  v-model="description"
                />
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <label class="col-sm-3 control-label">URL de imagen</label>
              <div class="col-sm-8">
                <div action="/action_page.php">
                  <input
                  type="file"
                  id="file"
                  ref="imageChooser"
                  class="form-control"
                  @change="updateChosenFile" multiple
                  ><br>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <label class="col-sm-3 control-label">Precio</label>
              <div class="col-sm-8">
                <input
                  type="text"
                  placeholder="Precio"
                  id="cost"
                  class="form-control"
                  v-model="cost"
                />
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-sm-3"></div>
              <div class="col-sm-8">
                <button class="btn btn-success " @click="$emit('add-item',[selectedSection,title,description,imageChosen,cost])">Agregar artículo</button>
                <br>
                <br>
                <button class="btn btn-primary " @click="$emit('cancel-item')">Cancelar</button>
              </div>

            </div>
             <br><br>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
export default {
    props:{
        section: Object
    },
    data(){
      return {
        selectedSection: "",
        title: "",
        description:"",
        imageChosen: "",
        cost:""
      }
    },
    methods: {
      updateChosenFile() {
        this.imageChosen = this.$refs.imageChooser.files[0]
      }
    }
}
</script>
